import React, { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Store, Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Primeiro acesso: define o nome da única loja da conta
const StoreSetupGate = ({ lojaAtual, onDone }) => {
  const [nome, setNome] = useState(lojaAtual || "");
  const [loading, setLoading] = useState(false);

  const salvar = async (e) => {
    e.preventDefault();
    if ((nome || "").trim().length < 2) return toast.error("Informe o nome da sua loja");
    try {
      setLoading(true);
      await axios.post(`${API}/config/onboarding`, { nome_loja: nome.trim() });
      toast.success("Loja configurada!");
      onDone();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao salvar o nome da loja");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[100dvh] bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="store-setup-gate">
        <div className="mx-auto w-14 h-14 bg-slate-900 rounded-full flex items-center justify-center mb-4">
          <Store className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 text-center">Qual o nome da sua loja?</h1>
        <p className="text-sm text-slate-500 text-center mt-1 mb-6">
          Sua conta começa com uma loja. Este nome aparece no sistema, no catálogo e nos comprovantes — você pode mudar depois em Configurações.
        </p>
        <form onSubmit={salvar} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-slate-700">Nome da loja</Label>
            <Input
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Ex: Ótica Visão Clara"
              className="h-11"
              data-testid="store-setup-input"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white" data-testid="store-setup-submit">
            <Check className="w-4 h-4 mr-2" /> {loading ? "Salvando..." : "Salvar e começar"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default StoreSetupGate;
